import styles from "./styles/wave-player-progress.module.scss";
import React from "react";

interface WavePlayerProgressProps {
  displayTime: boolean;
  formatTime: (value: number) => string;
  currentTime: number;
  duration: number;
  waveformRef: React.MutableRefObject<null>;
}

const WavePlayerProgress = ({
  displayTime,
  formatTime,
  currentTime,
  duration,
  waveformRef,
}: WavePlayerProgressProps) => {
  return (
    <div className={styles.player_wrapper}>
      {displayTime && (
        <span className={styles.time}>{formatTime(currentTime)}</span>
      )}
      <div ref={waveformRef} className={styles.waveform} />
      {displayTime && (
        <span className={styles.time}>{formatTime(duration)}</span>
      )}
    </div>
  );
};

export default WavePlayerProgress;
